module.exports = __webpack_public_path__ + "static/media/Miha.821b93da.jpg";